<template>
  <div width="100%">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <div :style="setTextWidth">
          <v-text-field
            class="datePickerTextField text-body-2"
            v-model="inputedValue"
            placeholder=""
            prepend-inner-icon="mdi-calendar"
            :height="height"
            readonly
            outlined
            hide-details
            v-bind="attrs"
            v-on="on"
            clearable
            :disabled="disabled"
          ></v-text-field>
        </div>
      </template>
      <v-date-picker
        v-model="inputedValue"
        :min="min"
        :max="max"
        :type="type"
        :value="value"
        width="300px"
        :color="color"
        @input="menu = false"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'NormalDatePicker',
  props: {
    value: {},
    min: { default: '2010-01-01' },
    max: { default: '2029-12-31' },
    height: { default: '32px' },
    width: { default: '140px' },
    color: { default: 'primary' },
    disabled: { default: false },
    type: { default: 'date' }
  },
  data: () => {
    return {
      date: '',
      menu: false
    }
  },
  computed: {
    setTextWidth() {
      return 'width: ' + this.width
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },

  watch: {
    value(newValue) {
      this.date = newValue
    }
  }
}
</script>
<style scoped lang="scss">
.datePickerTextField {
  ::v-deep .v-input__prepend-inner {
    margin-top: 5px !important;
  }
  ::v-deep .v-input__append-inner {
    margin-top: 5px !important;
  }
  ::v-deep .v-input__slot {
    padding: 0px 3px !important;
  }
}
</style>
